import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/Lag-SM-thumnail.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "md:max-w-xl",
    src: _imports_0
  })
], -1)

import Table from '@/components/Table.vue'
import axios from 'axios'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { ref } from 'vue'
import { ISeries } from './interfaces'
// Import Swiper styles
import 'swiper/swiper.scss'
// import Swiper core and required modules
import SwiperCore, { Autoplay, Pagination } from 'swiper/core'
// install Swiper modules

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

SwiperCore.use([Pagination, Autoplay])

const tournamentsRef = ref([] as ISeries[])
const tournaments = [
	{
		name: 'Pojkar 14',
		alias: 'P14',
		t: 'SBTF_SERIE_AVD15318',
		k: 'LS15318',
		p: '1',
	},
	{
		name: 'Flickor 14 A',
		alias: 'F14A',
		t: 'SBTF_SERIE_AVD15319',
		k: 'LS15319',
		p: '1',
	},
	{
		name: 'Flickor 14 B',
		alias: 'F14B',
		t: 'SBTF_SERIE_AVD16416',
		k: 'LS16416',
		p: '1',
	},
	{
		name: 'Pojkar 16',
		alias: 'P16',
		t: 'SBTF_SERIE_AVD15316',
		k: 'LS15316',
		p: '1',
	},
	{
		name: 'Flickor 16',
		alias: 'F16',
		t: 'SBTF_SERIE_AVD15317',
		k: 'LS15317',
		p: '1',
	},
	{
		name: 'Herrjuniorer 18',
		alias: 'HJ18',
		t: 'SBTF_SERIE_AVD15314',
		k: 'LS15314',
		p: '1',
	},
	{
		name: 'Damjuniorer 18 A',
		alias: 'DJ18A',
		t: 'SBTF_SERIE_AVD15315',
		k: 'LS15315',
		p: '1',
	},
	{
		name: 'Damjuniorer 18 B',
		alias: 'DJ18B',
		t: 'SBTF_SERIE_AVD16417',
		k: 'LS16417',
		p: '1',
	},
]

const classer = ['##', ...tournaments.map(({ alias }) => alias)]
const pagination = ref({
	clickable: true,
	renderBullet: (i: number) => {
		return `<span class="swiper-pagination-bullet">${classer[i]}</span>`
	},
})
const autoplay = ref({
	delay: 1000 * 15, // 20s
	disableOnInteraction: false,
})

const run = async () => {
	const url = 'https://api-pingisdata.onrender.com/table'
	const url2 = 'https://api-pingiskalk-wwr1.onrender.com/clubs/search'

	const tables = await Promise.all<ISeries>(
		tournaments
			.map(({ name, t, k, p }) => ({
				name,
				data: { t, k, p },
			}))
			.map(({ name, data }) =>
				axios.post(url, data).then(({ data: teams }) => ({
					name,
					teams,
				}))
			)
	)

	// Add image
	tables.forEach(async (tbl) => {
		const teamLogos = await Promise.all(
			tbl.teams.map((t) =>
				axios
					.post(url2, { search: t.team.replace(/\d+$/, '').trim() })
					.then(({ data }) => data)
					.then((res) => {
						if (res instanceof Object && res.image) {
							return res.image
						} else return ''
					})
					.then((str) => str.replaceAll('{size}', '40'))
			)
		)
		tbl.teams.forEach((t, i) => {
			t.image = teamLogos[i]
		})
	})

	tournamentsRef.value = tables
}

run()

// Refresh content after 5min
setInterval(run, 1000 * 60 * 5)

const onSwiper = (swiper: any) => {
	// console.log(swiper);
}

const onSlideChange = () => {
	// console.log("slide change");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Swiper), {
      "slides-per-view": 1,
      "space-between": 50,
      pagination: pagination.value,
      autoplay: autoplay.value,
      onSwiper: onSwiper,
      onSlideChange: onSlideChange,
      class: "tmp"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(SwiperSlide), null, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tournamentsRef.value, (t) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), {
            key: t.name
          }, {
            default: _withCtx(() => [
              _createVNode(Table, {
                name: t.name,
                teams: t.teams
              }, null, 8, ["name", "teams"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["pagination", "autoplay"])
  ]))
}
}

})